import React from 'react';
import { COLORS, TYPOGRAPHY } from '../../lib/styleGuide';

const headingFont = { fontFamily: 'Sora, sans-serif', fontWeight: 400 };
const bodyFont = { fontFamily: 'Montserrat, sans-serif', fontWeight: 400 };
const buttonFont = { fontFamily: 'Montserrat, sans-serif', fontWeight: 700 };

export default function ShopIntroStep({ onNext }) {
  return (
    <div style={{ minHeight: '80vh', display: 'flex', flexDirection: 'column', justifyContent: 'space-between', alignItems: 'center', width: '100%' }}>
      <div style={{ width: '100%', maxWidth: 400, margin: '0 auto', paddingTop: 32 }}>
        <div style={{ ...bodyFont, fontSize: TYPOGRAPHY.ONBOARDING.STEP_HEADING, color: '#222', marginBottom: 24 }}>Step 1:</div>
        <div style={{ 
          ...headingFont, 
          fontSize: TYPOGRAPHY.ONBOARDING.H2, 
          background: COLORS.PRIMARY_GRADIENT,
          backgroundClip: 'text',
          WebkitBackgroundClip: 'text',
          WebkitTextFillColor: 'transparent',
          marginBottom: 24, 
          lineHeight: 1.1 
        }}>Tell us about<br />your shop</div>
        <div style={{ ...bodyFont, fontSize: TYPOGRAPHY.ONBOARDING.STEP_DESCRIPTION, color: '#222', marginBottom: 0, lineHeight: 1.5 }}>
          In this step, we'll ask you what type of shop it is, what food you'll being creating and what amenities it offers. To wrap up, we'll need to know it's location so that we can be sure to find hungry close by neighbors.
        </div>
      </div>
      <div style={{ width: '100%', maxWidth: 400, margin: '0 auto', paddingBottom: 32 }}>
        <button
          type="button"
          onClick={() => onNext && onNext()}
          style={{
            width: '100%',
            background: COLORS.PRIMARY_GRADIENT,
            color: '#fff',
            border: 'none',
            borderRadius: 12,
            padding: '14px 0',
            fontSize: TYPOGRAPHY.ONBOARDING.BUTTON_TEXT,
            textTransform: 'uppercase',
            ...buttonFont,
            letterSpacing: 1,
            boxShadow: '0 2px 8px #0002',
            cursor: 'pointer',
            transition: 'all 0.2s',
          }}
          aria-label="Next"
        >
          NEXT
        </button>
      </div>
    </div>
  );
} 